import { formatDate } from '@helpers/date';
import { getRetinaSrcs } from '@helpers/image';
import { Device, from, until } from '@helpers/media';
import { SystemIcon, getSvgFromSystem } from '@helpers/systemIcons';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './CarouselCard.styles';
const CarouselCard = (props) => {
    const formattedDate = React.useMemo(() => formatDate(props.date, 'MMMM d, yyyy'), [props.date]);
    const columnAmountShown = props.columnAmount && (props.columnAmount > 4 ? 4 : props.columnAmount);
    const imageWidth = 1440 / (columnAmountShown ?? 2);
    const mobileImg = getRetinaSrcs(props.additionalImage ?? props.image, 430, 676);
    const img = getRetinaSrcs(props.image, imageWidth, 500);
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { as: props.cta?.url ? 'a' : 'button', type: "button", href: props.cta?.url, target: props.cta?.target ?? '_self', onClick: () => !props.cta?.url &&
                (props.setModelContent ? props.setModelContent(props) : null,
                    props.setModelOpen ? props.setModelOpen() : null), "data-card-size": props.size },
            React.createElement(S.Overlay, null),
            React.createElement(S.MediaArea, null,
                React.createElement("picture", null,
                    React.createElement("source", { media: from(Device.Tablet), srcSet: img.srcSet, sizes: `${until(Device.DesktopLarge)} ${100 / (columnAmountShown ?? 2)}vw, ${imageWidth}px` }),
                    React.createElement(S.Image, { alt: props.image?.altText ?? '', loading: "lazy", role: props.image?.altText ? undefined : 'presentation', src: mobileImg.src, srcSet: mobileImg.srcSet, sizes: `${until(Device.MobileLarge)} 331px, 430px` }))),
            React.createElement(S.ContentArea, { "data-has-date": props.date != undefined },
                React.createElement(S.Title, null, props.title),
                props.subTitle && React.createElement(S.Subtitle, null, props.subTitle),
                props.date && React.createElement(S.Date, null, formattedDate)),
            React.createElement(S.IconHolder, null, props.cta?.url ? (React.createElement(React.Fragment, null, props.icon === 'play'
                ? getSvgFromSystem(SystemIcon.PlayHollow)
                : getSvgFromSystem(SystemIcon.ArrowRightHollow))) : (getSvgFromSystem(SystemIcon.ExpandHollow))))));
};
export default CarouselCard;
